import { PRINT_SETTINGS } from '../../../routes'

import useTranslations from '../../../i18n/useTranslations'

import PrintAlertView from './View'

const PrinterNotConfiguredAlertView = ({ closeAlert }) => {
  const t = useTranslations()

  return (
    <PrintAlertView
      description={t('print-alert:printer-not-configured')}
      textButton={t('noun:go-to-print-settings')}
      urlButton={PRINT_SETTINGS.path}
      closeAlert={closeAlert}
    />
  )
}
PrinterNotConfiguredAlertView.propTypes = {
  closeAlert: PrintAlertView.propTypes.closeAlert,
}

export default PrinterNotConfiguredAlertView
